import { Button } from "@/components/tiptapNovel/ui/button";
import { cn } from "@/utils";
import { BoldIcon, ItalicIcon, StrikethroughIcon, UnderlineIcon } from "lucide-react";
import { EditorBubbleItem, useEditor } from "novel";
import type { SelectorItem } from "./node-selector";

export const TextButtons = () => {
  const { editor } = useEditor();
  if (!editor) return null;
  const items: SelectorItem[] = [
    {
      name: "bold",
      isActive: (editor) => editor!.isActive("bold"),
      command: (editor) => editor!.chain().focus().toggleBold().run(),
      icon: BoldIcon,
    },
    {
      name: "italic",
      isActive: (editor) => editor!.isActive("italic"),
      command: (editor) => editor!.chain().focus().toggleItalic().run(),
      icon: ItalicIcon,
    },
    {
      name: "underline",
      isActive: (editor) => editor!.isActive("underline"),
      command: (editor) => editor!.chain().focus().toggleUnderline().run(),
      icon: UnderlineIcon,
    },
    {
      name: "strike",
      isActive: (editor) => editor!.isActive("strike"),
      command: (editor) => editor!.chain().focus().toggleStrike().run(),
      icon: StrikethroughIcon,
    },
    // {
    //   name: "code",
    //   isActive: (editor) => editor.isActive("code"),
    //   command: (editor) => editor.chain().focus().toggleCode().run(),
    //   icon: CodeIcon,
    // },
  ];
  return (
    <div className="flex">
      {items.map((item) => (
        <EditorBubbleItem
          key={item.name}
          className="flex"
          onSelect={(editor) => {
            item.command(editor);
          }}
        >
          <Button size="sm" type="button" variant="ghost">
            <item.icon
              className={cn("w-4 h-4 text-[var(--tt-ink,#2c2a26)]", {
                "text-[var(--tt-accent,#2f4a6a)]": item.isActive(editor),
              })}
            />
          </Button>
        </EditorBubbleItem>
      ))}
    </div>
  );
};
